import { getPlanErknmStatusTitleByStatus } from 'APIPackage/PlanListModule/common/getPlanErknmStatusTitleByStatus';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { checkValueInEnum } from 'CorePackage/MainModule/common/checkValueInEnum';
import { RenderFunc } from 'KnmPackage/KnmHistoriesModule/types/RenderFunc';

export const renderErknmStatus: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue: checkValueInEnum<ErknmPlanStatusesEnum>(oldValue, Object(ErknmPlanStatusesEnum))
      ? getPlanErknmStatusTitleByStatus(oldValue) || ''
      : '',
    renderedNewValue: checkValueInEnum<ErknmPlanStatusesEnum>(newValue, Object(ErknmPlanStatusesEnum))
      ? getPlanErknmStatusTitleByStatus(newValue) || ''
      : '',
  };
};
